export default __webpack_public_path__ + "static/media/oval_trampolin.276f7033.png";